<bom-workspace>
  <ng-container *ngIf="signeringAnmodingInfo; else loadingAnmodning">
    <ng-container *ngIf="!signeringAnmodingInfo.erEgenUnderskrivning">
      <h1>Digital Signering</h1>
      <bom-alert type="info" [descriptionKey]="'DigitalSignering.Alert.Description'"> </bom-alert>
      <!--DigitalSignering.Rekvirent-->
      <section>
        <h2 class="section-header">{{ 'DigitalSignering.Rekvirent.Header' | tekstresource }}</h2>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{ '_ContactInfoName' | tekstresource }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.rekvirent.navn }}</span>
          </div>
        </div>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{ '_ContactInfoEmail' | tekstresource }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.rekvirent.email }}</span>
          </div>
        </div>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{ '_ContactInfoPhone' | tekstresource }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.rekvirent.telefon }}</span>
          </div>
        </div>
      </section>
      <!--DigitalSignering.Meddelelse-->
      <section>
        <h2 class="section-header">{{ 'DigitalSignering.Meddelelse.Header' | tekstresource }}</h2>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{
              'DigitalSignering.Meddelelse.Label' | tekstresource
            }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.beskedTilModtager }}</span>
          </div>
        </div>
      </section>
    </ng-container>
    <ng-container *ngIf="signeringAnmodingInfo.erEgenUnderskrivning">
      <h1>{{ 'DigitalSigneringOverskrift' | tekstresource }}</h1>
      <!--DigitalSignering.Rekvirent-->
      <section>
        <h2 class="section-header">Profiloplysninger</h2>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{ '_ContactInfoName' | tekstresource }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.rekvirent.navn }}</span>
          </div>
        </div>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{ '_ContactInfoEmail' | tekstresource }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.rekvirent.email }}</span>
          </div>
        </div>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{ '_ContactInfoPhone' | tekstresource }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.rekvirent.telefon }}</span>
          </div>
        </div>
      </section>
    </ng-container>
    <ng-container>
      <!-- DigitalSignering.Saginfo -->
      <section>
        <h2 class="section-header">{{ 'DigitalSignering.Saginfo.Header' | tekstresource }}</h2>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{
              'DigitalSignering.Saginfo.Label.Ansoegning' | tekstresource
            }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.sagNavn }}</span>
          </div>
        </div>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{
              'DigitalSignering.Saginfo.Label.Ansoegningstyper' | tekstresource
            }}</label>
          </div>
          <div class="col-10">
            <ng-container
              *ngIf="signeringAnmodingInfo.aktiviteterNavne.length === 1; else moreAktiviteter"
            >
              <span>{{ signeringAnmodingInfo.aktiviteterNavne[0] }}</span>
            </ng-container>
            <ng-template #moreAktiviteter>
              <ul>
                <li *ngFor="let aktivitetNavn of signeringAnmodingInfo.aktiviteterNavne">
                  {{ aktivitetNavn }}
                </li>
              </ul>
            </ng-template>
          </div>
        </div>
        <ng-container *ngIf="signeringAnmodingInfo.virksomhedSteder.length > 0">
          <div class="row mb-4 pl-5">
            <div class="col-2">
              <label class="form-label">{{
                'DigitalSignering.Saginfo.Label.Virksomheder' | tekstresource
              }}</label>
            </div>
            <div class="col-10">
              <ng-container
                *ngIf="
                  signeringAnmodingInfo.virksomhedSteder.length === 1;
                  else moreVirksomhedSteder
                "
              >
                <span>{{ signeringAnmodingInfo.virksomhedSteder[0] }}</span>
              </ng-container>
              <ng-template #moreVirksomhedSteder>
                <ul>
                  <li *ngFor="let adresse of signeringAnmodingInfo.virksomhedSteder">
                    {{ adresse }}
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="signeringAnmodingInfo.mainAdresseSteder.length > 0">
          <div class="row mb-4 pl-5">
            <div class="col-2">
              <label class="form-label">{{
                'DigitalSignering.Saginfo.Label.Adresser' | tekstresource
              }}</label>
            </div>
            <div class="col-10">
              <ng-container
                *ngIf="signeringAnmodingInfo.mainAdresseSteder.length === 1; else moreAdresseSteder"
              >
                <span>{{ signeringAnmodingInfo.mainAdresseSteder[0] }}</span>
              </ng-container>
              <ng-template #moreAdresseSteder>
                <ul>
                  <li *ngFor="let adresse of signeringAnmodingInfo.mainAdresseSteder">
                    {{ adresse }}
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="signeringAnmodingInfo.ejendomSteder.length > 0">
          <div class="row mb-4 pl-5">
            <div class="col-2">
              <label class="form-label">{{
                'DigitalSignering.Saginfo.Label.Ejendomme' | tekstresource
              }}</label>
            </div>
            <div class="col-10">
              <ng-container
                *ngIf="signeringAnmodingInfo.ejendomSteder.length === 1; else moreEjendomSteder"
              >
                <span>{{ signeringAnmodingInfo.ejendomSteder[0] }}</span>
              </ng-container>
              <ng-template #moreEjendomSteder>
                <ul>
                  <li *ngFor="let adresse of signeringAnmodingInfo.ejendomSteder">{{ adresse }}</li>
                </ul>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="signeringAnmodingInfo.matrikelSteder.length > 0">
          <div class="row mb-4 pl-5">
            <div class="col-2">
              <label class="form-label">{{
                'DigitalSignering.Saginfo.Label.Matrikler' | tekstresource
              }}</label>
            </div>
            <div class="col-10">
              <ng-container
                *ngIf="signeringAnmodingInfo.matrikelSteder.length === 1; else moreMatrikelSteder"
              >
                <span>{{ signeringAnmodingInfo.matrikelSteder[0] }}</span>
              </ng-container>
              <ng-template #moreMatrikelSteder>
                <ul>
                  <li *ngFor="let adresse of signeringAnmodingInfo.matrikelSteder">
                    {{ adresse }}
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="signeringAnmodingInfo.koordinatSteder.length > 0">
          <div class="row mb-4 pl-5">
            <div class="col-2">
              <label class="form-label">{{
                'DigitalSignering.Saginfo.Label.Koordinatsteder' | tekstresource
              }}</label>
            </div>
            <div class="col-10">
              <ng-container
                *ngIf="signeringAnmodingInfo.koordinatSteder.length === 1; else moreKoordinatSteder"
              >
                <span>{{ signeringAnmodingInfo.koordinatSteder[0] }}</span>
              </ng-container>
              <ng-template #moreKoordinatSteder>
                <ul>
                  <li *ngFor="let adresse of signeringAnmodingInfo.koordinatSteder">
                    {{ adresse }}
                  </li>
                </ul>
              </ng-template>
            </div>
          </div>
        </ng-container>
        <div class="row mb-4 pl-5">
          <div class="col-2">
            <label class="form-label">{{
              'DigitalSignering.Saginfo.Label.Myndighed' | tekstresource
            }}</label>
          </div>
          <div class="col-10">
            <span>{{ signeringAnmodingInfo.ansvarligMyndighed }}</span>
          </div>
        </div>
      </section>
    </ng-container>
    <ng-container>
      <!-- DigitalSignering.Dokumenter -->
      <section>
        <h2 class="section-header">{{ 'DigitalSignering.Dokumenter.Header' | tekstresource }}</h2>
        <div class="pl-5">
          <p class="mb-5">{{ 'DigitalSignering.Dokumenter.Read' | tekstresource }}</p>
          <h3>
            {{
              'DigitalSignering.Underskrift.Header'
                | tekstresource: { dokKrav: signeringAnmodingInfo.dokumentation.visningNavn }
            }}
          </h3>
          <p
            *ngIf="
              signeringAnmodingInfo.dokumentation.type === 'OrienteringDokumentation' &&
              signeringAnmodingInfo.dokumentation.orienteringTekst
            "
            [innerHTML]="signeringAnmodingInfo.dokumentation.orienteringTekst"
          ></p>
          <p
            *ngIf="
              signeringAnmodingInfo.dokumentation.type === 'RedegoerelseDokumentation' &&
              signeringAnmodingInfo.dokumentation.redegoerelseTekst
            "
            [innerHTML]="signeringAnmodingInfo.dokumentation.redegoerelseTekst"
          ></p>
          <div
            *ngIf="
              signeringAnmodingInfo.dokumentation.type === 'FormularDokumentation' &&
              signeringAnmodingInfo.dokumentation.formularXml != null
            ">
            <ng-container *ngFor="let element of signeringAnmodingInfo.dokumentation.formularElements">
              <p [innerHTML]="element.valueDisplayString"></p>
            </ng-container>
          </div>
          <ng-container *ngIf="signeringAnmodingInfo.dokumentation.dokumentationBilag.length > 0">
            <div class="bilag-container col-10">
              <div class="row row-header py-4">
                <div class="col pl-4">
                  {{ 'DigitalSignering.Dokumenter.Tableheader.Filnavn' | tekstresource }}
                </div>
              </div>
              <ng-container
                *ngFor="let bilag of signeringAnmodingInfo.dokumentation.dokumentationBilag"
              >
                <div class="row">
                  <div class="col p-4">
                    <bom-download-file
                      [displayText]="bilag.fileName"
                      [fileName]="bilag.fileName"
                      [url]="'signering/ticketbilag'"
                      [params]="{
                        ticket: encodedTicket,
                        bilagId: bilag.projektBilagRevisionId
                      }"
                    ></bom-download-file>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <!--DigitalSignering.Underskrift-->
          <p
            [innerHTML]="
              'DigitalSignering.Underskrift.Description' | tekstresource | externalizeLinks
            "
          ></p>
          <div class="row mb-6">
            <a [routerLink]="['mitid']">
              <bom-button
                type="primary"
                textKey="DigitalSignering.Underskrift.SignMitId"
                [disabled]="isFetchingSigningRequest"
              ></bom-button>
            </a>
          </div>
          <div class="row">
            <bom-button
              type="secondary"
              textKey="DigitalSignering.Underskrift.DownloadButton"
              [showSpinner]="isDownloading"
              [disabled]="isDownloading"
              (clicked)="downloadDokumentation()"
            >
              <ng-container bom-icon-before>
                <svg class="icon-svg icon-button mr-3">
                  <use xlink:href="#downloadicon"></use>
                </svg>
              </ng-container>
            </bom-button>
          </div>
        </div>
      </section>
    </ng-container>
  </ng-container>
  <ng-template #loadingAnmodning>
    <ng-container *ngIf="errorMessage | async as errorMsg; else showSpinner">
      <bom-alert
        type="error"
        titleHtml="Anmodningen er ikke tilgængelig"
        [descriptionHtml]="errorMsg"
      ></bom-alert>
    </ng-container>
    <ng-template #showSpinner>
      <bom-spinner [message]="'Henter anmodningen...'"></bom-spinner>
    </ng-template>
  </ng-template>
</bom-workspace>
